import { auth } from './firebase';
import { onIdTokenChanged } from 'firebase/auth';

/**
 * This service manages the authentication token.
 * It now uses Firebase ID Token synchronization.
 */

// Define a key to use for storing the token in localStorage.
const AUTH_TOKEN_KEY = 'laqy_auth_token';

// Listen for token changes and sync with localStorage
if (typeof window !== 'undefined') {
    onIdTokenChanged(auth, async (user) => {
        if (user) {
            const token = await user.getIdToken();
            localStorage.setItem(AUTH_TOKEN_KEY, token);
        } else {
            localStorage.removeItem(AUTH_TOKEN_KEY);
        }
    });
}

export const authService = {
    /**
     * Saves the authentication token to localStorage.
     */
    setToken: (newToken: string) => {
        if (typeof window !== 'undefined') {
            localStorage.setItem(AUTH_TOKEN_KEY, newToken);
        }
    },

    /**
     * Retrieves the authentication token from localStorage.
     */
    getToken: (): string | null => {
        if (typeof window !== 'undefined') {
            return localStorage.getItem(AUTH_TOKEN_KEY);
        }
        return null;
    },

    /**
     * Gets the current Firebase ID token if a user is logged in.
     */
    getFirebaseToken: async (): Promise<string | null> => {
        const user = auth.currentUser;
        if (user) {
            return await user.getIdToken(true);
        }
        return authService.getToken();
    },

    /**
     * Removes the authentication token from localStorage.
     */
    clearToken: () => {
        if (typeof window !== 'undefined') {
            localStorage.removeItem(AUTH_TOKEN_KEY);
        }
    },

    /**
     * Checks if a token exists in localStorage.
     */
    isAuthenticated: (): boolean => {
        const token = authService.getToken();
        return !!token;
    },
};
